import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { OidcProvider } from 'redux-oidc';

import App from './App';
import i18n from './i18n';
import { unregister } from './registerServiceWorker';
import store from './store';
import userManager from './utils/userManager';
import theme from './theme';

unregister();

const GlobalStyle = createGlobalStyle`
  body {
    padding: 0;
    font-family: 'Helvetica Neue', sans-serif;
    background-color: ${props => props.theme.background}
    color: ${props => props.theme.secondary}
  }
  button {
    outline: none;
  }
  form, fieldset {
    margin: auto;
    max-width: 480px;
  }
`;

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <React.Fragment>
      <I18nextProvider i18n={i18n}>
        <Provider store={store}>
          <OidcProvider store={store} userManager={userManager}>
            <App />
          </OidcProvider>
        </Provider>
      </I18nextProvider>
      <GlobalStyle />
    </React.Fragment>
  </ThemeProvider>,
  document.getElementById('root')
);
